import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
	state: {
		currentAtlasDisplayType: null, // Šiaip man nepatinka, kad globaliame APP store'e saugoma info apie konkretų atlasą... Ar tai normali praktika globaliame store'e saugoti info, kuri kitiems komponentams gali būti niekada neaktuali?
		activeWidget: null,
		testDelay: 0,
		userData: null,
		currentPageMaps: null,
		refMapView: null,
		legends: null
	},
	mutations: {
		setCurrentAtlasDisplayType(state, type){
			state.currentAtlasDisplayType = type;
		},
		setActiveWidget(state, widget){
			console.log("SET ACTIVE WIDGET...", widget); // TEMP...
			state.activeWidget = widget;
		},
		setUserData(state, userData){
			state.userData = userData;
		},
		setCurrentPageMaps(state, maps){
			state.currentPageMaps = maps;
			if (!maps) {
				state.refMapView = null;
			}
		},
		setRefMapView(state, refMapView){
			state.refMapView = refMapView;
		},
		setLegends(state, legends){
			state.legends = legends;
		}
	}
})
export default store;